<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-6"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Conta</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        <form @submit.prevent="onSubmit(form)">

            <Tabs v-model:value="tabIndex">
                <TabList>
                    <Tab :value="0">Informações</Tab>
                    <Tab :value="1" :disabled="!form.id">Arquivos</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel :value="0">
                        <ScrollPanel style="height: 62vh">
                            <div class="w-full">

                                <div class="field mt-4">
                                    <label class="block font-medium mb-3">Tipo de Lançamento <span class="text-red-500">*</span></label>
                                    <div class="flex gap-4 flex-wrap">
                                        <div class="flex align-items-center">
                                            <RadioButton v-model="form.tipo_conta" inputId="tipo_mensalidade" name="tipo_conta" value="mensalidade" />
                                            <label for="tipo_mensalidade" class="ml-2 cursor-pointer">Mensalidade</label>
                                        </div>

                                        <div class="flex align-items-center">
                                            <RadioButton v-model="form.tipo_conta" inputId="tipo_prorata" name="tipo_conta" value="prorata" />
                                            <label for="tipo_prorata" class="ml-2 cursor-pointer">Prorata</label>
                                        </div>

                                        <div class="flex align-items-center">
                                            <RadioButton v-model="form.tipo_conta" inputId="tipo_avulso" name="tipo_conta" value="avulso" />
                                            <label for="tipo_avulso" class="ml-2 cursor-pointer">Avulso/Outros</label>
                                        </div>
                                    </div>
                                    <div class="text-xs text-red-500 mt-1">{{ errors['tipo_conta'] }}</div>
                                </div>



                            <div class="field mt-4">
                                    <InputGroup>
                                        <FloatLabel>
                                            <InputText id="contrato_id" v-model="form.id_primario" class="w-full" readonly />
                                            <label for="contrato_id">Contrato<span class="text-red-500"> *</span></label>
                                        </FloatLabel>
                                        <Button icon="pi pi-search" severity="info" @click="visibleContratoListSelect = true"></Button>
                                        <Button icon="pi pi-times" severity="danger" @click="clearContrato"></Button>
                                    </InputGroup>
                                    <div class="text-xs text-red-500">{{ errors['contrato_id'] }}</div>
                            </div>

                            <div class="list-none p-0 m-0 flex flex-row gap-4 mt-4">


                                <div class="flex-1">

                                    <FloatLabel>
                                        <InputNumber id="valor" v-model="form.valor" :minFractionDigits="2" :maxFractionDigits="5" class="w-full" prefix="R$ " fluid />
                                        <label for="valor">Valor<span class="text-red-500"> *</span></label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['valor'] }}</div>
                                </div>

                                <div class="flex-1" >


                                        <FloatLabel>
                                                    <DatePicker id="data_vencimento" v-model="form.data_vencimento"
                                                        showIcon class="w-full" dateFormat="dd/mm/yy" />
                                                    <label for="data_vencimento">Vencimento<span class="text-red-500"> *</span></label>
                                        </FloatLabel>


                                    <div class="text-xs text-red-500">{{ errors['data_vencimento'] }}</div>
                                </div>

                                <div class="flex-1" >


                                    <FloatLabel>
                                                <DatePicker id="data_pagamento" v-model="form.data_pagamento"
                                                    showIcon class="w-full" dateFormat="dd/mm/yy" />
                                                <label for="data_pagamento">Data Pagamento</label>
                                    </FloatLabel>


                                    <div class="text-xs text-red-500">{{ errors['data_pagamento'] }}</div>
                                </div>


                            </div>

                                <div class="field mt-4">

                                        <FloatLabel>
                                            <Textarea id="observacao" v-model="form.observacao" class="w-full" rows="7" cols="30" />
                                            <label for="observacao">Observação</label>
                                        </FloatLabel>

                                    <div class="text-xs text-red-500">{{ errors['cliente_id'] }}</div>
                                    </div>




                            </div>
                        </ScrollPanel>

                    </TabPanel>

                    <TabPanel :value="1">
                        <ScrollPanel style="height: 62vh">
                            <FormTabArquivos v-if="form.id" :data="form" @save="onUploadFile" @remove="onRemoveFile" />
                        </ScrollPanel>

                    </TabPanel>
                </TabPanels>
            </Tabs>
            <div class="flex justify-content-end flex-wrap">


                <div class="flex justify-content-end gap-1">
                    <Button
                        :disabled="tabIndex != 0"
                        type="submit"
                        label="Salvar"
                        severity="success"
                        icon="pi pi-save"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                    <Button
                        label="Fechar"
                        severity="warn"
                        icon="pi pi-times"
                        size="small"
                        @click="updateVisible(false)"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                </div>
            </div>
        </form>
        <ContratoListSelect :visible="visibleContratoListSelect" @close="visibleContratoListSelect=false" @select="selectContrato" />
        <LogForm :visible="visibleLogForm" table="contas" :tableId="form.id" @close="this.visibleLogForm=false" />

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import DatePicker from 'primevue/datepicker';
import Textarea from 'primevue/textarea';
import FileUpload from 'primevue/fileupload';
import ScrollPanel from 'primevue/scrollpanel';

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import ContratoListSelect from '@/page/contrato/ListaSelect.vue';
import FormTabArquivos from '@/page/conta/FormTabArquivos.vue';

import Conta from '@/service/conta.js';

import LogForm from '@/components/LogForm.vue';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        InputMask,
        Select,
        AutoComplete,
        Checkbox,
        RadioButton,
        InputNumber,
        InputGroup,
        InputGroupAddon,
        DatePicker,
        Textarea,
        FileUpload,
        ScrollPanel,

        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,

        LogForm,
        ContratoListSelect,
        FormTabArquivos,
    },
    props: {
        visible: false,
        data: {},
    },
    emits: ['save', 'close'],
    data() {
        return {
            contrato: {},
            form: {},
            errors: {},
            isLoading: false,
            visibleContratoListSelect: false,

            visibleLogForm: false,

            tabIndex: 0,
        }
    },
    watch: {
        'form.tipo_conta'(novoTipo) {
            // Limpa o erro quando o usuário seleciona uma opção
            if (novoTipo) {
                delete this.errors['tipo_conta'];
            }
            // Atualiza o valor automaticamente quando o tipo muda e já tem contrato selecionado
            this.atualizarValorPorTipo(novoTipo);
        }
    },
    methods: {
        onUploadFile(event) {
            switch (event.route) {
                case 'comprovante':
                    this.form.comprovante_id = event.data.id;
                    this.form.comprovante = event.data.nome;
                    this.form.comprovante_date = event.data.created_at;
                    this.form.comprovante_usuario = event.data.usuario.nome;
                    break;

                default:
                    this.form.boleto_id = event.data.id;
                    this.form.boleto = event.data.nome;
                    this.form.boleto_date = event.data.created_at;
                    this.form.boleto_usuario = event.data.usuario.nome;
                    this.form.codigo_de_barras = event.data.conta.codigo_de_barras;
                    break;
            }
            this.$emit('save');
        },
        onRemoveFile(route) {
            switch (route) {
                case 'comprovante':
                    this.form.comprovante_id = null;
                    this.form.comprovante = null;
                    this.form.comprovante_date = null;
                    this.form.comprovante_usuario = null;
                    break;

                default:
                    this.form.boleto_id = null;
                    this.form.boleto = null;
                    this.form.boleto_date = null;
                    this.form.boleto_usuario = null;
                    this.form.codigo_de_barras = null;
                    break;
            }
            this.$emit('save');
        },
        selectContrato(contrato){
            this.contrato = contrato; // Guarda o contrato para referência
            this.form.id_primario   = contrato.id_primario;
            this.form.contrato_id   = contrato.id;
            // Atualiza o valor baseado no tipo selecionado
            this.atualizarValorPorTipo(this.form.tipo_conta);
        },

        atualizarValorPorTipo(tipo) {
            if (!this.contrato || !this.contrato.id) return;
            
            if (tipo === 'mensalidade') {
                // Para mensalidade, usa o valor com desconto ou valor original da cotação
                this.form.valor = this.contrato.cotacao_valor_desconto || this.contrato.cotacao_valor;
            } else if (tipo === 'prorata') {
                // Para prorata, pode usar o valor mensal proporcional (você pode ajustar a lógica)
                this.form.valor = this.contrato.cotacao_valor_desconto || this.contrato.cotacao_valor;
            }
            // Para 'avulso', não preenche automaticamente - o usuário define manualmente
        },

        clearContrato() {
            this.contrato = {};
            this.form.id_primario = null;
            this.form.contrato_id = null;
        },

        onShow() {
            this.errors = {};
            this.form = Conta.parse({ ...this.data });
        },
        onHide() {
            this.tabIndex = 0;
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if (form.id) {
                return Conta.update(form.id, form);
            }
            return Conta.create(form);
        },
        onSubmit(form) {
            this.errors = {};

            // Validação Frontend: Impede salvar sem escolher o tipo
            if (!form.tipo_conta) {
                this.errors['tipo_conta'] = 'Selecione o tipo da conta.';
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Selecione se é Mensalidade, Prorata ou Avulso.', life: 3000 });
                return;
            }

            this.isLoading = true;

            // Tradução tipo_conta para mensalidade/prorata
            let dadosParaEnviar = { ...form };
            if (form.tipo_conta === 'mensalidade') {
                dadosParaEnviar.mensalidade = 1;
                dadosParaEnviar.prorata = 0;
            } else if (form.tipo_conta === 'prorata') {
                dadosParaEnviar.mensalidade = 0;
                dadosParaEnviar.prorata = 1;
            } else {
                // Avulso
                dadosParaEnviar.mensalidade = 0;
                dadosParaEnviar.prorata = 0;
            }

            this.save(dadosParaEnviar)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.form = Conta.parse(response.data.data);
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response) {
                        let err = error.response.data;
                        if (err.erros) {
                            for (let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>
